import { ListSummaryModel } from '../../microsoft/sharepoint/list-summary-model';

export class WebSummaryModel {
  id: string;
  title: string;
  webs: WebSummaryModel[];
  lists: ListSummaryModel[];
  url: string;
}
